/*
 * Public API Surface of ng-selectize
 */

export * from './lib/ng-selectize.component';
export * from './lib/ng-selectize.module';
